<div [attr.data-cy]="'page-not-found-view'" class="d-flex align-items-center h-100">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-auto">
        <h1 class="display-3">404</h1>
      </div>
      <div class="col-md-auto">
        <h4 class="pt-3">{{ (title() ? title() : 'route.not_found.title') | translate }}</h4>
        @if (message(); as message) {
          <p [innerHtml]="message || 'route.not_found.message' | translate"></p>
        }
        <p>
          <a routerLink="/" nkButton color="secondary" size="lg"
            ><i class="fa fa-home me-2"></i> {{ 'route.not_found.link' | translate }}</a
          >
        </p>
      </div>
    </div>
  </div>
</div>
